export default array => {
  if (array) {
    let output = {};
    array.forEach(event => {
      if (event.category) {
        const caterogyId = event.category.id;
        if (!output.hasOwnProperty(caterogyId)) {
          output[caterogyId] = {
            id: caterogyId,
            label: event.category.detail.label,
            slug: event.category.detail.slug,
            items: [
              {
                id: event.id,
                title: event.detail.name,
                date: event.detail.date,
                slug: event.detail.slug,
                visualDesk: event.visual_desktop,
                visualMob: event.visual_mobile
              }
            ]
          };
        } else {
          output[caterogyId].items = output[caterogyId].items.concat({
            id: event.id,
            title: event.detail.name,
            date: event.detail.date,
            slug: event.detail.slug,
            visualDesk: event.visual_desktop,
            visualMob: event.visual_mobile
          });
        }
      }
    });
    return output;
  }
};
